import { useMemo, useState } from "react";
import VideoCard from "@/components/feature/VideoCard";
import Pagination from "@/components/feature/Pagination";
import SectionHeader from "@/components/feature/SectionHeader";
import { getAllVideos, paginate } from "@/lib/videoService";

const PAGE_SIZE = 8;

export default function LatestUpdates() {
  const [page, setPage] = useState(1);
  const latest = useMemo(
    () => getAllVideos().slice().sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)),
    []
  );
  const { items, totalPages, currentPage } = paginate(latest, page, PAGE_SIZE);

  return (
    <section className="w-full px-4 md:px-8 mt-14 md:mt-16">
      <SectionHeader
        title="最新更新"
        description="每日同步更新，第一时间发现最新上线的高清影视内容"
        moreTo="/category/电影"
        moreLabel="进入分类浏览"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {items.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
      <div className="mt-8">
        <Pagination currentPage={currentPage} totalPages={totalPages} onSelect={setPage} />
      </div>
    </section>
  );
}